import { DOCUMENT, Injectable, inject } from '@angular/core';
import { EXPORT_EXTENSION } from '../../../Consts/export.const';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  private readonly _document = inject(DOCUMENT);

  save(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const anchor = this._document.createElement('a');

    anchor.href = url;
    anchor.download = filename;
    anchor.click();

    URL.revokeObjectURL(url);
  }

  timestampedName(prefix: string): string {
    const stamp = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 15);

    return `${prefix}-${stamp}.${EXPORT_EXTENSION}`;
  }
}
